export default __webpack_public_path__ + "static/media/014-fire-alarm-1.a6e8258c.png";